const CONTROL_ACCESO_TURNS_LIST = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.controlaccesoturns = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

const CONTROL_ACCESO_TURNS_TABLE = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.status = 'success'
    alert(listpermiss.message)
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

const CONTROL_ACCESO_TURNS_EDIT = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.controlaccesoturns = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

export default {
  CONTROL_ACCESO_TURNS_LIST,
  CONTROL_ACCESO_TURNS_TABLE,
  CONTROL_ACCESO_TURNS_EDIT
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/turns/mutations.js